import React, { FC } from "react";
import styles from "./Switch.module.css";
import classNames from "classnames";
import Colors from "ui-kit/colors";
import { useLottieAnimation } from "hooks/useLottieAnimation";
import Stars from "../../assets/animations/stars.json";

type SwitchProps = {
  active: boolean;
  activeColor?: keyof typeof Colors;
  onChange: VoidFunction;
  "aria-labelledby": string;
};

const Switch: FC<SwitchProps> = ({
  active,
  activeColor = "green300",
  onChange,
  ...rest
}) => {
  const ref = useLottieAnimation({ animation: Stars, loop: false });

  return (
    <button
      className={styles.container}
      aria-pressed={active}
      onClick={onChange}
      {...rest}
    >
      <div
        className={classNames(styles.track, active && styles.active)}
        style={{
          backgroundColor: active ? Colors[activeColor] : Colors.grey200,
        }}
      />
      <div className={classNames(styles.indicator, active && styles.active)} />
      {active ? (
        <div ref={ref} className={styles.sparkles} aria-hidden />
      ) : null}
    </button>
  );
};

export default Switch;
